import Icon from "components/Icons/Icon";

const HowStep = ({ title, text, icon = "article", count }) => {
  return (
    <div className="how-step">
      <div className="how-step__image">
        <div className="count">{count}</div>
        {
          //@ts-ignore
          <Icon name={icon} />
        }
      </div>
      <div className="how-step_content">
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  );
};

export default HowStep;
